import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Webhook } from "lucide-react";
import api from "@/lib/api";
import { SESSION_EXPIRED_EVENT } from "@/components/SessionExpiredDialog";

const STYLE = {
  ok: "bg-[#10B981]/10 border-[#10B981]/30 text-[#10B981]",
  warn: "bg-[#F59E0B]/10 border-[#F59E0B]/30 text-[#D97706]",
  error: "bg-[#EF4444]/10 border-[#EF4444]/30 text-[#DC2626]",
  off: "bg-slate-100 border-slate-200 text-slate-500",
};
const DOT = { ok: "bg-[#10B981]", warn: "bg-[#F59E0B]", error: "bg-[#EF4444] animate-pulse", off: "bg-slate-400" };

export const WebhookStatusBadge = () => {
  const [st, setSt] = useState(null);
  useEffect(() => {
    const load = () => api.get("/whatsapp/webhook/status").then((r) => setSt(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    const stop = () => clearInterval(id);
    window.addEventListener(SESSION_EXPIRED_EVENT, stop);
    return () => { clearInterval(id); window.removeEventListener(SESSION_EXPIRED_EVENT, stop); };
  }, []);
  if (!st || st.level === "off") return null;
  const when = st.last_event_at ? new Date(st.last_event_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "mai";
  return (
    <Link to="/integrazioni" title={`Ultimo evento Meta: ${when}`} data-testid="webhook-status-badge" data-level={st.level}
          className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border text-xs font-medium transition-colors hover:opacity-80 ${STYLE[st.level]}`}>
      <span className={`h-2 w-2 rounded-full ${DOT[st.level]}`} />
      <Webhook className="h-3.5 w-3.5" /> <span data-testid="webhook-status-label">{st.label}</span>
    </Link>
  );
};
